import React, { Component } from 'react'
import styles from './style.module.less'
import { Modal, Input } from 'hljd'
import { observer } from 'mobx-react'
import store from '../store'

@observer
export default class extends Component {
  render() {
    const {
      cardPayVisible,
      user_name,
      user_idcard,
      user_bankcard,
      user_phone
    } = store

    return (
      <Modal
        closable={false}
        footer={null}
        width={690}
        visible={cardPayVisible}
      >
        <div className={styles.modalbox}>
          <p className={styles.title}>银行卡支付</p>
          <div className={styles.inner}>
            <div className={styles.form}>
              <div className={styles.item}>
                <span className={styles.tip}>真实姓名</span>
                <Input
                  style={{ width: 350 }}
                  placeholder="输入本人真实姓名"
                  value={user_name}
                  onChange={store.changeValue('user_name')}
                />
              </div>
              <div className={styles.item}>
                <span className={styles.tip}>身份证号</span>
                <Input
                  style={{ width: 350 }}
                  placeholder="请输入身份证号"
                  value={user_idcard}
                  onChange={store.changeValue('user_idcard')}
                />
              </div>
              <div className={styles.item}>
                <span className={styles.tip}>银行账号</span>
                <Input
                  style={{ width: 350 }}
                  placeholder="请输入银行卡号"
                  value={user_bankcard}
                  onChange={store.changeValue('user_bankcard')}
                />
              </div>
              <div className={styles.item} style={{ margin: 0 }}>
                <span className={styles.tip}>银行预留手机号</span>
                <Input
                  value={user_phone}
                  style={{ width: 350 }}
                  placeholder="请输入银行手机号"
                  onChange={store.changeValue('user_phone')}
                />
              </div>
            </div>
          </div>
          <div className={styles.btnClick}>
            <span className={styles.yes} onClick={store.toSubmit}>
              提交
            </span>
            <span className={styles.close} onClick={store.closeModal}>
              关闭
            </span>
          </div>
        </div>
      </Modal>
    )
  }
}
